// @ts-nocheck
import { FieldsDictionary } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";

export default <TOptions>(fieldDictionary: FieldsDictionary, options?: TOptions): FoundationFieldDefinition[] => {
    if (!options) {
        return [];
    }

    const fieldDefinition: FoundationFieldDefinition[] = [];

    for (const key in options) {
        const option = (options as any)[key];

        if (option) {
            const field = fieldDictionary[key];

            fieldDefinition.push(field as FoundationFieldDefinition);
        }
    }

    return fieldDefinition;
};
